import React, { CSSProperties, ReactNode, useEffect, useState } from 'react';

import RequiredSpan from '../components/RequiredSpan';

import 'input-time-polyfill';
import { DateTime } from 'luxon';

import './TimePicker.scoped.scss';

interface Props {
  error?: string;
  style?: CSSProperties;
  label?: string;
  placeholder?: string;
  required?: boolean;
  value?: any; // remember to delete ? when refactor
  appendIcon?: ReactNode;
  onChange: (val: any) => void;
  size?: 'small' | 'normal';
  disabled?: boolean;
}

const TimePicker: React.FC<Props> = ({
  error,
  label,
  onChange,
  required,
  style,
  size = 'normal',
  placeholder,
  value,
}) => {
  const [time, setTime] = useState(value);

  useEffect(() => {
    const tm = document.getElementById('time-input') as HTMLInputElement;
    const date = tm.value.length ? DateTime.fromISO(tm.value) : DateTime.now();
    onChange(date.toFormat('HH:mm'));
  }, [time]);

  const handleOnBlur = event => {
    setTime(event.target.value);
  };

  return (
    <div className="theme-input">
      {label ? (
        <label>
          <RequiredSpan required={required} />
          {label}
        </label>
      ) : (
        <div />
      )}
      <div className="input-container">
        <input
          type="text"
          className={`time-picker ${size} time-polyfill polyfill-left-aligned`}
          style={{ ...style }}
          placeholder={placeholder}
          value={time}
          min="00:00"
          max="23:59"
          id="time-input"
          onBlur={event => handleOnBlur(event)}
        />
      </div>
      {error ? <p className="error-text">{error}</p> : <div />}
    </div>
  );
};

export default TimePicker;
